{
  "chapel": {
    "id": "corner-chapel",
    "u": 2.1,
    "v": 0.35,
    "angleDeg": 77.45,
    "length": 22,
    "width": 9,
    "eaves": 9.6,
    "ridge": 14.8,
    "bays": 5,
    "roof": "slate"
  },
  "ranges": [
    {
      "id": "molensteeg-range",
      "u": 23,
      "v": -7.5,
      "angleDeg": 0,
      "length": 32,
      "width": 7,
      "eaves": 7.4,
      "ridge": 11.6,
      "floors": 2,
      "bays": 8,
      "roof": "slate"
    },
    {
      "id": "achterburgwal-range",
      "u": 4.85,
      "v": 21.2,
      "angleDeg": 77.45,
      "length": 24,
      "width": 6.8,
      "eaves": 7.8,
      "ridge": 11.9,
      "floors": 2,
      "bays": 6,
      "roof": "tile"
    },
    {
      "id": "zeedijk-hospital",
      "u": 31.5,
      "v": 9,
      "angleDeg": 106.25,
      "length": 24,
      "width": 6.2,
      "eaves": 5.6,
      "ridge": 8.9,
      "floors": 2,
      "bays": 6,
      "roof": "tile",
      "passage": 2.6
    },
    {
      "id": "zeedijk-patershuis",
      "u": 24.5,
      "v": 28,
      "angleDeg": 95.85,
      "length": 16,
      "width": 6.5,
      "eaves": 6.7,
      "ridge": 10,
      "floors": 2,
      "bays": 4,
      "roof": "tile"
    },
    {
      "id": "north-court-range",
      "u": 15,
      "v": 35.3,
      "angleDeg": 0,
      "length": 17,
      "width": 5.8,
      "eaves": 4.4,
      "ridge": 7.4,
      "floors": 1,
      "bays": 4,
      "roof": "slate"
    }
  ],
  "court": [
    [9.8, -2.5],
    [29, -2.5],
    [24, 17.5],
    [21, 19],
    [20, 30.8],
    [11.2, 30.8],
    [7.8, 13],
    [9.8, 12]
  ],
  "garden": { "u0": 12, "u1": 19.5, "v0": 5, "v1": 25, "rows": 4, "columns": 2 },
  "entry": { "u0": -1.3, "u1": 1.3, "v0": -3.1, "v1": 6.4 },
  "entryRange": "zeedijk-hospital",
  "roofGables": {
    "range": "molensteeg-range",
    "centres": [-8, 0, 8],
    "halfWidth": 0.75,
    "v0": 2,
    "v1": 3.35,
    "eaves": 9.4,
    "ridge": 10.5,
    "note": "Three court-facing roof gables follow the woodcut’s visible rhythm; exact spacing, heights, roof cuts and openings are estimates."
  },
  "note": "Baart’s excavation account distinguishes the corner chapel, long street-side convent buildings, Zeedijk hospital and Patershuis. The painting and labelled 1544 woodcut guide the unequal mass hierarchy and open court. Reservation, fitted part positions, metre dimensions, roof coverings, heights, windows, belfry, garden beds and the hospital-to-court access are estimates, not excavated measurements. The expression one verdieping does not settle the hospital’s exact storey count; the lower two-level mass is provisional. The Molensteeg and Achterburgwal ranges are not assigned specific unexcavated rooms. Later residential refronting, the Chinese temple and the full modern block are not substituted for the medieval compound."
}
